<template>
  <div>
    <!-- 关联标签 -->
    <div class="common-form mt50">标签设置</div>
    <el-form-item size="small" label="选择标签">
      <el-button icon="el-icon-plus" @click="changeProduct(form.labelList)">选择商品标签</el-button>
      <div class="pb50">
        <el-tag v-for="(tag,index) in form.labelList" :key="tag.name" closable :disable-transitions="false" @close="deleteClick(index)" :type="tag.type"> {{ tag.name }}</el-tag>
      </div>
    </el-form-item>
    <!--标签选择-->
    <Label :isproduct="isproduct" :excludeLabelIds="excludeLabelIds" :islist="true" @closeDialog="closeDialogFunc"></Label>

  </div>
</template>

<script>
import Label from '@/components/product/Label';
import {mergeTable} from '@/utils/table.js';

export default {
  components: {
    /*选择商品组件*/
    Label,
  },
  data() {
    return {
      unit: '%',
      isproduct: false,
      /*产品去重*/
      excludeLabelIds: [],
    };
  },
  props: {
    form: Object,
    type: String
  },
  methods: {
    /*关闭弹窗*/
    /*关闭弹窗*/
    closeDialogFunc(e) {
      console.log(e)
      let self = this;
      self.isproduct = false;
      if (e.type == 'success') {
        let arr = [];
        for (let i = 0; i < e.params.length; i++) {
          let item = e.params[i];
          let obj = {
            name: item.name,
            kmd_label_id: item.kmd_label_id
          };
          arr.push(obj);
        }
        self.form.labelList = self.form.labelList.concat(arr);
        self.form.labelList = mergeTable(this.form.labelList);
      }
    },
    /*打开添加*/
    changeProduct(list) {
      let arr = [];
      list.forEach(item => {
        arr.push(item.kmd_label_id);
      });
      this.excludeLabelIds = arr;
      this.isproduct = true;
    },
    /*删除标签*/
    deleteClick(e) {
      let curItem = this.form.labelList[e];
      for (let i = 0; i < this.form.labelList.length; i++) {
        let item = this.form.labelList[i];
        if (curItem.kmd_label_id == item.kmd_label_id) {
          if (this.type == 'edit' && e.tempProduct != true) {
            let kmd_label_id = item.kmd_label_id;
            this.form.product_label_del_ids.push(kmd_label_id);
          }
          this.form.labelList.splice(i, 1);
          i--;
        }
      }
    },
  }
};
</script>

<style>
.el-tag + .el-tag {
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/product/product/part/Label.vue